import React from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../../ui/Collapsible";
import { usePhysicsStore } from "../../../stores/physicsStore";

/** Subscribes to step-rate stats only; avoids repainting the rest of the panel ~1 Hz. */
export default function PhysicsPanelPerformanceSection() {
  const isRunning = usePhysicsStore((s) => s.isRunning);
  const isPaused = usePhysicsStore((s) => s.isPaused);
  const lastStepHz = usePhysicsStore((s) => s.lastStepHz);
  const [elapsedSeconds, setElapsedSeconds] = React.useState(0);
  const active = isRunning || isPaused;

  React.useEffect(() => {
    if (!active) {
      setElapsedSeconds(0);
      return undefined;
    }

    const handlePoses = (event) => {
      const nextTime = Number(event?.detail?.time);
      if (Number.isFinite(nextTime)) {
        setElapsedSeconds(Math.max(0, nextTime));
      }
    };

    window.addEventListener("physics-poses", handlePoses);
    return () => window.removeEventListener("physics-poses", handlePoses);
  }, [active]);

  return (
    <>
      <Collapsible defaultOpen>
        <CollapsibleTrigger quiet className="w-full text-xs text-gray-200 justify-between">
          Stats
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="flex items-baseline gap-8 px-10 py-5">
            <div className="flex min-w-0 items-baseline gap-2">
              <span className="text-xs font-medium text-gray-400 select-none">Elapsed</span>
              <span className="text-sm text-gray-200 tabular-nums select-none">
                {elapsedSeconds.toFixed(2)} s
              </span>
            </div>
            <div className="flex min-w-0 items-baseline gap-2">
              <span className="text-xs font-medium text-gray-400 select-none">Step Rate</span>
              <span className="text-sm text-gray-200 tabular-nums select-none">
                {active ? `${lastStepHz} Hz` : "--"}
              </span>
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>
      <div className="h-px bg-gray-700 my-2" />
    </>
  );
}
